import { combineReducers } from "redux";
import usuarioReducer from "./usuario-reducer"; // Lida com dados do usuario
import usersPageReducer from "../../routers/administracao/usuarios/reducers/users-page-reducer";
import cashbackReducer from "../../routers/cashback/cashback/reducers/cashback-reducer";

export default combineReducers({
  usuario: usuarioReducer,
  usersPage: usersPageReducer,
  cashbackPage: cashbackReducer,
});
